export default __webpack_public_path__ + "static/media/kooiring_verend_3x.37e2ee45.png";